import { Anchor, Portal, Root, Trigger } from '@radix-ui/react-popover'

import { PopoverContent } from './PopoverContent'

export const Popover = Object.assign(Root, {
  Content: PopoverContent,
  Portal,
  Anchor,
  Trigger
})

Root.displayName = 'Popover'
